export default "__VITE_ASSET__D0$EtAj1__"